import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import classNames from 'classnames';
import { Select } from '../select/Select';
import Option from '../option/Option';
import OptGroup from '../option/OptGroup';
import TransferList from './TransferList';
import TransferOperation from './TransferOperation';
import TransferSort from './TransferSort';
import autobind from '../_util/autobind';
import isSameLike from '../_util/isSameLike';
let Transfer = class Transfer extends Select {
    constructor(props, context) {
        super(props, context);
        this.isCustom = false;
        this.clearCurrentIndex = () => {
            const current = this.options.current;
            if (current) {
                current.isCurrent = false;
            }
        };
        this.changeOptionIndex = () => {
            const { valueField, options } = this;
            const targetValues = this.getValues(); // 这是有顺序的
            let optionData = options.data;
            const sortOpt = [];
            targetValues.forEach(key => {
                optionData = optionData.filter(record => {
                    if (record.get(valueField) !== key) {
                        return true;
                    }
                    sortOpt.push(record);
                    return false;
                });
            });
            optionData.unshift(...sortOpt);
            this.options.data = optionData;
        };
        this.handleRemove = (value) => {
            this.removeValues([value]);
            this.updateIndex();
        };
        runInAction(() => {
            this.sourceSelected = [];
            this.targetSelected = [];
            this.clearCurrentIndex();
        });
        this.isCustom = typeof props.children === 'function';
    }
    sourceFilter(record, index, array) {
        const { valueField, props: { optionsFilter }, } = this;
        if (optionsFilter && !optionsFilter(record, index, array)) {
            return false;
        }
        const values = this.getValues();
        if (values.length) {
            return values.every(v => !isSameLike(record.get(valueField), v));
        }
        return true;
    }
    targetFilter(record, index, array) {
        const { valueField, props: { optionsFilter }, } = this;
        if (optionsFilter && !optionsFilter(record, index, array)) {
            return false;
        }
        const values = this.getValues();
        if (values.length) {
            return values.some(v => isSameLike(record.get(valueField), v));
        }
        return false;
    }
    handleMenuClick({ item: { props: { value }, }, }) {
        if (this.multiple) {
            this.selectRecord(value, this.sourceSelected);
        }
        else {
            this.prepareSetValue(this.processRecordToObject(value));
        }
    }
    handleTargetMenuClick({ item: { props: { value }, }, }) {
        if (this.multiple) {
            this.selectRecord(value, this.targetSelected);
        }
        else {
            this.removeValue(value);
        }
        this.options.locate(value.index);
    }
    handleMoveToLeft() {
        const { valueField, isCustom } = this;
        if (!isCustom) {
            this.removeValues(this.targetSelected.map(record => record.get(valueField)));
        }
        else {
            let currentValues = this.getValues();
            const targetKeys = this.targetSelected.map(record => record.key);
            for (const key of targetKeys) {
                currentValues = currentValues.filter(record => record.key !== key);
            }
            this.setValue(currentValues);
        }
        this.targetSelected = [];
        this.updateIndex();
    }
    handleMoveToRight() {
        const { valueField } = this;
        this.prepareSetValue(...(this.isCustom ? this.sourceSelected : this.sourceSelected.map(record => record.get(valueField))));
        this.sourceSelected = [];
        this.updateIndex();
    }
    handleSortTo(direction) {
        const { valueField, options } = this;
        const { current } = options;
        if (current) {
            const targetFilteredOptions = options.getState('targetFilteredOptions');
            if (targetFilteredOptions) {
                const to = direction === 'up' ? -1 : 1;
                const currentValue = current.get(valueField);
                const index = targetFilteredOptions.findIndex(record => record.get(valueField) === currentValue);
                const currentOpt = targetFilteredOptions[index];
                const moveOpt = targetFilteredOptions[index + to];
                if (currentOpt && moveOpt) {
                    const currentOptValue = currentOpt.get(valueField);
                    const moveOptValue = moveOpt.get(valueField);
                    const optionsCurrentIndex = options.findIndex(record => record.get(valueField) === currentOptValue);
                    const optionsMoveIndex = options.findIndex(record => record.get(valueField) === moveOptValue);
                    if (optionsCurrentIndex !== -1 && optionsMoveIndex !== -1) {
                        options.move(optionsCurrentIndex, optionsMoveIndex);
                    }
                }
            }
        }
    }
    handleSourceSelectAllChange(selected) {
        this.sourceSelected = selected;
    }
    handleTargetSelectAllChange(selected) {
        this.targetSelected = selected;
    }
    selectRecord(value, selected) {
        const index = selected.indexOf(value);
        if (index !== -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(value);
        }
    }
    updateIndex() {
        this.changeOptionIndex();
        this.clearCurrentIndex();
    }
    renderWrapper() {
        const { disabled, prefixCls, targetSelected, sourceSelected, multiple, valueField, props: { titles = [], operations = [], sortOperations = [], sortable, oneWay }, } = this;
        const targetValues = this.getValues();
        const currentTarget = this.options.current;
        let upActive = false;
        let downActive = false;
        let currentIndex = currentTarget ? targetValues.findIndex(x => x === currentTarget.get(valueField)) : -1;
        const targetFilteredOptions = this.options.getState('targetFilteredOptions');
        if (targetFilteredOptions && currentTarget) {
            currentIndex = targetFilteredOptions.findIndex(record => record.get(valueField) === currentTarget.get(valueField));
            upActive = currentIndex > -1 && currentIndex !== 0;
            downActive = currentIndex > -1 && currentIndex !== targetFilteredOptions.length - 1;
        }
        const classNameString = classNames(`${prefixCls}-wrapper`, {
            [`${prefixCls}-sortable`]: sortable,
        });
        let oneWayProps = {};
        if (oneWay) {
            oneWayProps = {
                multiple: false,
                onRemove: this.handleRemove,
            };
        }
        let customOption = {};
        if (this.isCustom) {
            customOption = {
                targetOption: targetValues,
            };
        }
        return (React.createElement("span", { key: "wrapper", className: classNameString },
            React.createElement(TransferList, Object.assign({}, this.props, { options: this.options, selected: sourceSelected, header: titles[0], onSelectAll: this.handleSourceSelectAllChange, onSelect: this.handleMenuClick, optionsFilter: this.sourceFilter, direction: "left" }, customOption)),
            React.createElement(TransferOperation, { className: `${prefixCls}-operation`, leftActive: !(!targetSelected.length || disabled), rightActive: !(!sourceSelected.length || disabled), rightArrowText: operations[0], leftArrowText: operations[1], moveToLeft: this.handleMoveToLeft, moveToRight: this.handleMoveToRight, multiple: multiple, oneWay: oneWay }),
            React.createElement(TransferList, Object.assign({}, this.props, { options: this.options, selected: targetSelected, header: titles[1], currentIndex: currentIndex, onSelectAll: this.handleTargetSelectAllChange, onSelect: this.handleTargetMenuClick, optionsFilter: this.targetFilter, direction: "right" }, customOption, oneWayProps)),
            sortable && !this.isCustom && (React.createElement(TransferSort, { className: `${prefixCls}-sort`, upActive: upActive, downActive: downActive, upArrowText: sortOperations[0], downArrowText: sortOperations[1], moveToUp: () => this.handleSortTo('up'), moveToDown: () => this.handleSortTo('down'), multiple: multiple }))));
    }
};
Transfer.displayName = 'Transfer';
Transfer.defaultProps = {
    ...Select.defaultProps,
    suffixCls: 'transfer',
    multiple: true,
    sortable: false,
    oneWay: false,
};
Transfer.Option = Option;
Transfer.OptGroup = OptGroup;
__decorate([
    observable
], Transfer.prototype, "sourceSelected", void 0);
__decorate([
    observable
], Transfer.prototype, "targetSelected", void 0);
__decorate([
    observable
], Transfer.prototype, "targetCurrentSelected", void 0);
__decorate([
    autobind
], Transfer.prototype, "sourceFilter", null);
__decorate([
    autobind
], Transfer.prototype, "targetFilter", null);
__decorate([
    autobind
], Transfer.prototype, "handleMenuClick", null);
__decorate([
    autobind
], Transfer.prototype, "handleTargetMenuClick", null);
__decorate([
    autobind,
    action
], Transfer.prototype, "handleMoveToLeft", null);
__decorate([
    autobind,
    action
], Transfer.prototype, "handleMoveToRight", null);
__decorate([
    autobind,
    action
], Transfer.prototype, "handleSortTo", null);
__decorate([
    autobind,
    action
], Transfer.prototype, "handleSourceSelectAllChange", null);
__decorate([
    autobind,
    action
], Transfer.prototype, "handleTargetSelectAllChange", null);
__decorate([
    action
], Transfer.prototype, "selectRecord", null);
__decorate([
    action
], Transfer.prototype, "clearCurrentIndex", void 0);
__decorate([
    action
], Transfer.prototype, "updateIndex", null);
Transfer = __decorate([
    observer
], Transfer);
export default Transfer;
